module.exports = __webpack_public_path__ + "static/media/video.8f2c86e6.svg";